export const generateCalendarLink = (
    title: string,
    startDateStr: string,
    endDateStr: string,
    location?: string,
    description?: string
  ): string => {
    // Convertir les chaînes de date en objets Date
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    
    // Format pour iCalendar - YYYYMMDDTHHMMSSZ
    const formatDateForICS = (date: Date) => {
      return date.toISOString().replace(/[-:]/g, '').replace(/\.\d+/g, '');
    };
    
    const startDateFormatted = formatDateForICS(startDate);
    const endDateFormatted = formatDateForICS(endDate);
    const now = formatDateForICS(new Date());
    
    // Générer un UID unique pour l'événement
    const uid = `event-${Date.now()}-${Math.floor(Math.random() * 100000)}@tournoispadel.com`;
    
    // Échapper les caractères spéciaux
    const escapeICS = (text: string) => {
      if (!text) return '';
      return text
        .replace(/,/g, '\\,')
        .replace(/;/g, '\\;')
        .replace(/\n/g, '\\n');
    };
    
    const escapedTitle = escapeICS(title);
    const escapedLocation = escapeICS(location || '');
    const escapedDescription = escapeICS(description || '');
    
    // Créer le contenu du fichier ICS
    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//TournoisPadel//Calendar//FR',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      `UID:${uid}`,
      `DTSTAMP:${now}`,
      `DTSTART:${startDateFormatted}`,
      `DTEND:${endDateFormatted}`,
      `SUMMARY:${escapedTitle}`,
      `DESCRIPTION:${escapedDescription}`,
      `LOCATION:${escapedLocation}`,
      'STATUS:CONFIRMED',
      'SEQUENCE:0',
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');
    
    // Encoder en base64 pour la compatibilité avec les URL de données
    const base64 = btoa(unescape(encodeURIComponent(icsContent)));
    
    return `data:text/calendar;charset=utf-8;base64,${base64}`;
  };